import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { SenderRegistration as SENDER_ADD } from 'Components/Api/PaysprintDMTAPI';
import { FetchDetailsForPincode as FETCH_DETAILS_FOR_PINCODE } from 'Components/Api/UsersApi';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import AutoSubmitPincode from 'Components/Helper/AutoSubmitPincode';
import { Container, Grid, Paper, Button, Hidden } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const SenderAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const location = useLocation();
    const State = location.state.State;
    const Mobile = location.state.Mobile;
    const Pipe = location.state.Pipe;
    const StateResp = location.state.StateResp;
    const EKYCID = location?.state?.EKYCID;
    const AadharNum = location?.state?.AadharNum;

    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        Pincode: '',
        OTP: '',
        Address: '',
        State: State,
        StateResp: StateResp,
        EKYCID: EKYCID,
        AadharNum: AadharNum
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        setResponseMessage('');

        var request = {
            Name: values.Name,
            PinCode: values.Pincode,
            Mobile: values.Mobile,
            OTP: values.OTP,
            Address: values.Address,
            State: values.State,
            StateResp: values.StateResp,
            EKYCID: values.EKYCID,
            AadharNum: values.AadharNum
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await SENDER_ADD(requestObj);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        setLoading(false);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            setIsError(true);
            return;
        }

        resetForm(formObject);
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);
        var param = {
            Mobile: request.Mobile
        };
        history.push('/PS_SenderSearch', param);
    };
    const FetchDetails = async (values, setFieldValue) => {
        var request = {
            Pincode: values.Pincode
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        setIsError(true);
        setSeverity('success');

        if (!response.status) {
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        var data = JSON.parse(response.data);

        setFieldValue(
            'Address',
            data.CityName + ',' + data.District + ',' + data.State
        );
    };
    const select = () => {
        setLoading(false);

        setFormObject({
            ...formObject,
            Mobile: Mobile,
            Name: '',
            PinCode: '',
            OTP: '',
            State: State,
            Address: ''
        });
    };

    useEffect(() => {
        select();
    }, []);

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'name')
            .min(8, PLEASE_PROVIDE_VALID + 'at least 8 length name'),
        Pincode: Yup.string().required(PLEASE_PROVIDE_VALID + 'PinCode'),
        OTP: Yup.string().required(PLEASE_PROVIDE_VALID + 'OTP')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                            style={{
                                justifyContent: 'center'
                            }}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <AutoSubmitPincode
                                        callback={() => {
                                            FetchDetails(values, setFieldValue);
                                        }}
                                    />
                                    <h2 className={classes.PaperHead_h2}>
                                        Sender Add
                                    </h2>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="Mobile"
                                                        length={10}
                                                        readOnly={true}
                                                        placeholder="Mobile"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Name"
                                                        name="Name"
                                                        type="text"
                                                        placeholder="Name"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="PinCode"
                                                        name="Pincode"
                                                        type="text"
                                                        length={6}
                                                        placeholder="PinCode"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Address"
                                                        name="Address"
                                                        type="text"
                                                        placeholder="Address"
                                                    />
                                                </Grid>
                                                <Hidden xsUp>
                                                    <MaterialTextField
                                                        label="State"
                                                        name="State"
                                                        type="text"
                                                        readOnly={true}
                                                        placeholder="State"
                                                    />
                                                </Hidden>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="OTP"
                                                        name="OTP"
                                                        type="text"
                                                        length={6}
                                                        placeholder="OTP"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                                style={{
                                                    display: 'flex',
                                                    gap: '30px'
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => {
                                                        history.push(
                                                            '/PS_SenderSearch',
                                                            {
                                                                Mobile: Mobile,
                                                                Pipe: Pipe
                                                            }
                                                        );
                                                    }}
                                                    style={{
                                                        width: '180px'
                                                    }}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        </CustomContainer>
    );
};
